import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight, Linkedin, Twitter } from "lucide-react";
import { navLinks, contactInfo, ecosystem } from "../mock";
import Logo from "./Logo";

const Footer = () => {
  return (
    <footer className="section-navy text-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 md:grid-cols-4 md:px-8">
        <div className="md:col-span-1">
          <Logo dark className="mb-5" />
          <p className="max-w-xs text-sm leading-relaxed text-white/60">
            Twenty years connecting business with opportunity — in India and
            around the world.
          </p>
          <div className="mt-6 flex gap-3">
            {[Linkedin, Twitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                aria-label="social"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors duration-200 hover:bg-white/20"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.18em] text-white/50">
            Explore
          </h4>
          <ul className="space-y-3 text-sm">
            {navLinks
              .filter((l) => l.dropdown !== "ecosystem")
              .map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.path}
                    className="text-white/70 transition-colors duration-200 hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.18em] text-white/50">
            Ecosystem
          </h4>
          <ul className="space-y-3 text-sm">
            {ecosystem.branches.map((b) => (
              <li key={b.id}>
                <a
                  href={b.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-white/70 transition-colors duration-200 hover:text-white"
                >
                  {b.name} <ArrowUpRight className="h-3.5 w-3.5" />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.18em] text-white/50">
            Get in touch
          </h4>
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 flex-shrink-0 text-[#E7625B]" />
              <a href={`tel:${contactInfo.phoneRaw}`} className="hover:text-white">
                {contactInfo.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 flex-shrink-0 text-[#E7625B]" />
              <a href={`mailto:${contactInfo.email}`} className="hover:text-white">
                {contactInfo.email}
              </a>
            </li>
            {contactInfo.offices.map((o) => (
              <li key={o.city} className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#E7625B]" />
                <span>
                  <span className="block text-[11px] font-semibold uppercase tracking-[0.14em] text-white/50">
                    {o.label} · {o.city}
                  </span>
                  <span className="mt-0.5 block leading-relaxed">{o.address}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 py-5 text-center text-sm text-white/50 md:px-8">
          © {new Date().getFullYear()} Continex. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
